export default {
  metadata: {
    version: '1.0.0',
    id: 'input-code-1.0.0',
    name: 'JDSInputCode'
  },
  hierarchy: {
    container: [
      {
        'field-container': ['jds_input_code_item']
      },
      'jds_feedback_block',
      'helper-jds-text'
    ]
  },
  base: {
    container: {
      'flex-direction': '{i_0}',
      'justify-content': '{i_1}',
      'align-items': '{i_2}',
      width: '{i_3}',
      gap: '{i_4}',
      opacity: '{i_11}'
    },
    'field-container': {
      'flex-direction': '{i_5}',
      'justify-content': '{i_6}',
      'align-items': '{i_7}',
      width: '{i_8}',
      gap: '{i_9}'
    },
    jds_input_code_item: {
      flex: 1
    },
    jds_feedback_block: {
      size: 's',
      state: 'none'
    },
    'helper-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{i_10}'
        }
      }
    },
    state: {
      success: {
        jds_feedback_block: {
          state: 'success'
        }
      },
      error: {
        jds_feedback_block: {
          state: 'error'
        }
      },
      warning: {
        jds_feedback_block: {
          state: 'warning'
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      disabled: {
        values: [false, true]
      },
      state: {
        type: 'JDSFeedbackBlock.state',
        values: ['none', 'success', 'error', 'warning']
      }
    },
    data: {
      container: {
        '_codes.value': {
          type: 'string',
          name: 'value'
        },
        '_codes.placeholder': {
          type: 'string',
          name: 'placeholder'
        }
      },
      'field-container': {
        value: {
          type: 'list',
          name: '_codes',
          object: {
            value: 'string',
            placeholder: 'string'
          }
        },
        length: {
          type: 'number',
          name: 'codeLength',
          doc_description: 'It can be used to control length of Code.'
        }
      },
      jds_input_code_item: {
        state: {
          type: 'JDSFeedbackBlock.state',
          name: 'state',
          doc_description:
            "It can be used to choose between states i.e. 'success','warning','error','none'.By default it is 'none'."
        },
        disabled: {
          type: 'boolean',
          name: 'disabled',
          doc_description: 'It can be used to enable or disable Code.'
        },
        value: {
          type: 'string',
          name: 'codes.value'
        },
        placeholder: {
          type: 'string',
          name: 'codes.placeholder'
        },
        required: {
          type: 'boolean',
          name: 'required',
          doc_description: 'It can be used to make input required.'
        },
        secureText: {
          type: 'boolean',
          name: 'secureText'
        },
        focusRequester: {
          type: 'focusRequester',
          name: 'focusRequester',
          platform: 'android'
        }
      },
      jds_feedback_block: {
        stateText: {
          type: 'string',
          name: 'stateText',
          doc_description:
            'It displays message with respect to its [state] selected.'
        }
      },
      'helper-jds-text': {
        value: {
          type: 'string',
          name: 'helperText',
          doc_description: 'It displays helper text of Code.'
        }
      }
    },
    events: {
      jds_input_code_item: {
        onFocus: 'onFocus',
        onBlur: 'onBlur',
        onChange: 'onChange',
        onSubmit: 'onSubmit',
        onKeydown: {
          name: 'onKeydown',
          platform: 'web'
        },
        onPaste: 'onPaste',
        onInvalid: 'onInvalid'
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'input'
          },
          'aria-label': {
            name: 'ariaLabel'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
